import { ROUTE_ID_MAPPING_WEB, ROUTE_ID_MAPPING_TERMINAL } from '../config/ids/idsRoutes';

export function getNextResort(resortId, resorts) {
    return resorts.indexOf(resortId) >= resorts.length - 1 ? resorts[0] : resorts[resorts.indexOf(resortId) + 1];
}

export function getPreviousResort(resortId, resorts) {
    return resorts.indexOf(resortId) === 0 ? resorts[resorts.length - 1] : resorts[resorts.indexOf(resortId) - 1];
}

export function mapResortPathToId(resortPath, season) {
    return ROUTE_ID_MAPPING_WEB[season][resortPath];
}

export function mapResortIdToPath(resortId, season) {
    return Object.keys(ROUTE_ID_MAPPING_WEB[season]).find(key => ROUTE_ID_MAPPING_WEB[season][key] === resortId);
}

export function mapTerminalResortPathToId(resortPath, season) {
    return ROUTE_ID_MAPPING_TERMINAL[season][resortPath];
}
